import { createContext } from 'react';

export type NavSectionId = 'hobby' | 'play' | 'you';

/** Set by SectionLayout so Page can render the matching sub-navigation. */
export const SectionContext = createContext<NavSectionId | null>(null);
